(function(){
    angular.module('Directives').directive('paymentGatewaysDetails', paymentGatewaysDetails);
    paymentGatewaysDetails.$inject = [
        'PaymentGatewaysTableService'
    ];

    function paymentGatewaysDetails(
        PaymentGatewaysTableService
    ){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/paymentGatewaysDetails.html',
            scope: {},
            link: paymentGatewaysDetailsLink
        }

        function paymentGatewaysDetailsLink($scope, $attrs, $elements) {
            init();
            function init() {
               initPaymentGatewaysTable();
            }

            function initPaymentGatewaysTable() {
                $scope.paymentGatewaysTable = new PaymentGatewaysTableService().tableData;
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/paymentGatewaysDetails.js